import { ImagesSkusFiltersBlackSvg } from '@/assets/images_skus.assets';
import Image from 'next/image';
import SkusMobileAlgoliaShowMenuFilter from './SkusMobileAlgoliaShowMenuFilter';
import SkusMobileAlgoliaShowStatusFilter from './SkusMobileAlgoliaShowStatusFilter';
import SkusMobileAlgoliaShowPricesFilter from './SkusMobileAlgoliaShowPricesFilter';
import SkusMobileAlgoliaRefinementList from './SkusMobileAlgoliaRefinementList';
import { useCurrentRefinements } from 'react-instantsearch';
import DefaultButton from '@/components/common/default/DefaultButton';
import { ImagesSkusCloseSvg } from '@/assets/images_skus.assets';
import { CgClose } from 'react-icons/cg';
import { SkusMobileAlgoliaShowFiltersProps } from '@/types/props/components/skus';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { SkusEnum } from '@/types/translations/SkusEnum';
export default function SkusMobileAlgoliaShowFilters({
  setFiltersAreOpen,
}: SkusMobileAlgoliaShowFiltersProps) {
  const { translate } = useTypedTranslation<SkusEnum>('skus');
  const { items, refine } = useCurrentRefinements();

  return (
    <div className="tw-w-full tw-fixed tw-top-12 tw-left-0 tw-min-h-screen tw-bg-white tw-z-[999]">
      <div className="tw-px-8 tw-pt-12 tw-max-h-[800px] tw-overflow-y-scroll">
        <div className="tw-flex tw-flex-col tw-gap-3 tw-border-custom-gray tw-border-0.75 tw-border-solid tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-pb-3">
          <div className="tw-flex tw-items-center tw-justify-between">
            <div className="tw-flex tw-items-center tw-gap-3 tw-w-full">
              <Image
                src={ImagesSkusFiltersBlackSvg}
                width={24}
                height={14.4}
                alt="Filters"
              />
              <strong className="tw-font-plusJakartaSans tw-font-semibold tw-text-xl tw-text-textBlack">
                {translate(SkusEnum['filters'])}
              </strong>
            </div>
            <DefaultButton
              onClick={() => setFiltersAreOpen(false)}
              aria-label={translate(SkusEnum['close_filters'])}
            >
              <CgClose />
            </DefaultButton>
          </div>
          <div className="tw-pt-2 tw-flex tw-items-center tw-justify-start tw-flex-wrap tw-gap-2">
            {items.map((filter) =>
              filter.refinements.map((refinement) => (
                <DefaultButton
                  key={refinement.value}
                  className="tw-flex tw-items-center tw-gap-4 tw-py-2 tw-px-4 tw-bg-customGray tw-rounded-lg"
                  onClick={() => refine(refinement)}
                >
                  {filter.label === 'hasBid'
                    ? translate(SkusEnum['has_bids'])
                    : filter.label === 'hasAsk'
                      ? translate(SkusEnum['has_asks'])
                      : refinement.label}{' '}
                  <Image
                    src={ImagesSkusCloseSvg}
                    width={10.5}
                    height={10.5}
                    alt={translate(
                      SkusEnum['remove_filterName_filter']
                    ).replace('{filterName}', String(refinement.value))}
                  />
                </DefaultButton>
              ))
            )}
          </div>
        </div>
        <div className="tw-pt-3">
          <ul className="tw-p-0 tw-list-none tw-w-full tw-flex tw-flex-col tw-gap-4 tw-border tw-border-custom-gray tw-border-solid tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-pb-4">
            <SkusMobileAlgoliaShowMenuFilter />
            <SkusMobileAlgoliaShowStatusFilter />
            <SkusMobileAlgoliaShowPricesFilter />
          </ul>
          <ul className="tw-p-0 tw-list-none tw-w-full tw-flex tw-flex-col tw-gap-4 tw-border tw-border-custom-gray tw-border-solid tw-border-r-0 tw-border-l-0 tw-border-t-0 tw-pb-4">
            <SkusMobileAlgoliaRefinementList
              attributeName="brand.countryOfOrigin"
              title={translate(SkusEnum['country'])}
            />
            <SkusMobileAlgoliaRefinementList
              attributeName="brand.name"
              title={translate(SkusEnum['brand'])}
            />
            <SkusMobileAlgoliaRefinementList
              attributeName="brand.region"
              title={translate(SkusEnum['region'])}
            />

            <SkusMobileAlgoliaRefinementList
              attributeName="bottleSizeInMl"
              title={translate(SkusEnum['bottle_size'])}
            />

            <SkusMobileAlgoliaRefinementList
              attributeName="subCategory"
              title={translate(SkusEnum['subcategory'])}
            />

            <SkusMobileAlgoliaRefinementList
              attributeName="volumeInPercent"
              title={translate(SkusEnum['alcoholPercentage'])}
            />
            <SkusMobileAlgoliaRefinementList
              attributeName="productAge"
              title={translate(SkusEnum['age'])}
            />
            <SkusMobileAlgoliaRefinementList
              attributeName="yearBottled"
              title={translate(SkusEnum['bottled_year'])}
            />
          </ul>
        </div>
      </div>
    </div>
  );
}
